export default {
  jiraServiceDesk: 'jiraServiceDesk',
  iDocSign: 'iDocSign'
}
